import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectors as apiSelectors } from 'zender-api-client';
import * as appSelectors from '../../../../../selectors';

import Shoutbox from './Shoutbox.component';

const ShoutboxContainer = props => <Shoutbox {...props} />;

const mapStateToProps = state => ({
	enabled: apiSelectors.shoutbox.enabledSelector(state),
	shouts: apiSelectors.shoutbox.reverseStarredShoutsSelector(state),
	locale: appSelectors.locale.localeSelector(state),
});

const mapDispatchToProps = () => ({});

ShoutboxContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ShoutboxContainer);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/shoutbox/Shoutbox.container.js